import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCartQuery } from '@/features/cart/cartApi';
import { CustomerIcon } from './CustomerIcon';
import { QrScannerDialog } from './QrScannerDialog';

export function CustomerBottomNavigation({ storeCode }: { storeCode?: string }) {
  const location = useLocation();
  const [scannerOpen, setScannerOpen] = useState(false);
  const cart = useCartQuery();
  const count = cart.data?.items?.reduce((sum, item) => sum + (item.quantity ?? 0), 0) ?? 0;
  const menuPath = storeCode ? `/store/${encodeURIComponent(storeCode)}/menu#menu` : '/menu';
  return (
    <>
      <nav className="customer-bottom-nav" aria-label="Điều hướng nhanh">
        <Link to="/" aria-current={location.pathname === '/' ? 'page' : undefined}>
          <CustomerIcon name="home" />
          Trang chủ
        </Link>
        <Link
          to={menuPath}
          aria-current={location.pathname.includes('/menu') ? 'page' : undefined}
          aria-label={count ? `Thực đơn, giỏ hàng có ${count} món` : 'Thực đơn'}
        >
          <CustomerIcon name="menu" />
          Thực đơn
        </Link>
        <button
          className="bottom-nav-qr"
          type="button"
          aria-label="Mở camera quét QR Order"
          onClick={() => setScannerOpen(true)}
        >
          <CustomerIcon name="qr" />
        </button>
        <Link
          to="/moods"
          aria-current={location.pathname.startsWith('/moods') ? 'page' : undefined}
        >
          <CustomerIcon name="mood" />
          Mood
        </Link>
        <Link to="/stores" aria-current={location.pathname === '/stores' ? 'page' : undefined}>
          <CustomerIcon name="pin" />
          Cửa hàng
        </Link>
      </nav>
      <QrScannerDialog open={scannerOpen} onClose={() => setScannerOpen(false)} />
    </>
  );
}
